import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../../layouts/AuthLayout";
import Field from "../../components/Field";
import styles from "./LoginPage.module.css";
import { useLoginForm } from "./useLoginForm";

export default function LoginPage() {
  const navigate = useNavigate();
  const { values, errors, submittedOnce, canSubmit, setField, onSubmit, isLoading, formError } =
    useLoginForm({
      onSuccess: () => navigate("/console", { replace: true }),
    });

  return (
    <AuthLayout>
      <h2 className={styles.title}>Log In</h2>

      <p className={styles.subtitle}>
        Need an account?{" "}
        <Link to="/request" className={styles.link}>
          Sign Up
        </Link>
      </p>

      <form className={styles.form} onSubmit={onSubmit} noValidate>
        {formError ? <div className={styles.formError}>{formError}</div> : null}

        <Field
          label="Email*"
          placeholder="you@company.com"
          value={values.email}
          onChange={(v) => setField("email", v)}
          error={errors.email}
          type="email"
          inputMode="email"
          name="email"
          autoComplete="email"
          disabled={isLoading}
        />

        <Field
          label="Password*"
          placeholder="Enter your password"
          value={values.password}
          onChange={(v) => setField("password", v)}
          error={errors.password}
          type="password"
          name="password"
          autoComplete="current-password"
          disabled={isLoading}
        />

        <button
          className={styles.primaryBtn}
          type="submit"
          disabled={isLoading || (!canSubmit && submittedOnce)}
        >
          {isLoading ? "Signing in..." : "Log In"}
        </button>

        <p className={styles.legal}>
          2026 Ridebase Mobility Systems LLC, All rights Reserved
        </p>
      </form>
    </AuthLayout>
  );
}